<template>
  <footer :class="{ dark: isAIActive() }">
    <div class="footer__wrapper">
      <div class="footer__top">
        <div class="footer__logo">
          <inline-svg class="footer__logo-logo-image" :src="`/images/v4/svg/logo-coverse${ isAIActive() ? '' : '-color' }.svg`" />
          <div class="footer__logo-social-links">
            <a class="footer__logo-social-link" href="https://t.me/CoverseTeam" target="_blank">
              <inline-svg class="social-link-image" src="/images/v4/svg/logo-telegram.svg" />
              <inline-svg class="social-link-image-gray" src="/images/v4/svg/logo-telegram-gray.svg" />
            </a>
            <a class="footer__logo-social-link" href="https://vk.com/coverse" target="_blank">
              <inline-svg class="social-link-image" src="/images/v4/svg/logo-vk.svg" />
              <inline-svg class="social-link-image-gray" src="/images/v4/svg/logo-vk-gray.svg" />
            </a>
          </div>
        </div>

        <div class="footer__content">
          <div class="footer__section footer__section-product">
            <div class="footer__section-title">Продукт</div>

            <a class="footer__section-link" href="/">Главная</a>
            <a class="footer__section-link" :href="`/pricing${urlQuery}`">Тарифы</a>
            <a class="footer__section-link" href="https://app.coverse.team/login" target="_black">Авторизация</a>
          </div>

          <div class="footer__section footer__section-help">
            <div class="footer__logo-social-links">
              <a class="footer__logo-social-link" href="https://t.me/CoverseTeam" target="_blank">
                <inline-svg class="social-link-image" src="/images/v4/svg/logo-telegram-mobile.svg" />
                <inline-svg class="social-link-image-gray" src="/images/v4/svg/logo-telegram-mobile-gray.svg" />
              </a>
              <a class="footer__logo-social-link" href="https://vk.com/coverse" target="_blank">
                <inline-svg class="social-link-image" src="/images/v4/svg/logo-vk-mobile.svg" />
                <inline-svg class="social-link-image-gray" src="/images/v4/svg/logo-vk-mobile-gray.svg" />
              </a>
            </div>
            <div class="footer__section-title">Помощь</div>
            <a class="footer__section-link" href="https://support.coverse.team" target="_black">База знаний</a>
            <a class="footer__section-link" href="https://support.coverse.team/category/4608" target="_black">С чего начать</a>
            <a class="footer__section-link" href="https://support.coverse.team/category/4615" target="_black">FAQ</a>
          </div>

          <div class="footer__section footer__section-documents">
            <div class="footer__section-title">Документы</div>
            <a class="footer__section-link" href="https://coverse.team/privacy" target="_blank">Конфиденциальность</a>
            <a class="footer__section-link" href="https://coverse.team/agreement" target="_blank">Соглашение</a>
          </div>
        </div>
      </div>

      <div class="footer__bottom">
        <div class="footer__bottom-copyright">
          © {{ new Date().getFullYear() }} ООО «Риверсити»
        </div>
        <div class="footer__bottom-links">
          <a class="footer__bottom-link" href="https://coverse.team/accreditation" target="_blank">
            Аккредитованная IT-компания
            <inline-svg src="/images/v4/svg/mc.svg" />
          </a>
          <a class="footer__bottom-link" href="https://isamara.ru/baza-innovatsionnykh-proektov/1495/" target="_blank">
            Резидент
            <img alt="Жигулёвская долина" src="/images/v4/images/zd.png" />
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      isMainActive: () => {
        return this.$route.name === 'main';
      },
      isPricingActive: () => {
        return this.$route.name === 'pricing';
      },
      isAIActive: () => {
        return this.$route.name === 'ai';
      },
    }
  },
}
</script>

<style scoped lang="scss">
@import "@/../node_modules/bootstrap/scss/functions";
@import "@/../node_modules/bootstrap/scss/variables";
@import "@/../node_modules/bootstrap/scss/mixins";
@import "@/../node_modules/bootstrap/scss/utilities";
@import "@/styles/breakpoints";
@import "@/styles/fonts";

footer {
  font-size: 14px;
  position: relative;
  z-index: 5;

  .footer__wrapper {
    max-width: 1000px;
    padding: 51px 0 50px;
    margin: 0 auto;
    border-top: 1px solid #DAE8E8;

    .footer__top {
      display: flex;
      padding: 0 0 50px;
    }

    .footer__logo {
      width: 100%;
      max-width: 308px;

      .footer__logo-logo-image {
        width: 144px;
      }

      .footer__logo-social-links {
        display: flex;
        margin-top: 20px;
      }
    }

    .footer__content {
      flex: 1 0 auto;
      display: flex;
      flex-wrap: wrap;
      gap: 40px;
    }

    .footer__section {
      width: 100%;
      flex: 0 0 auto;
      display: flex;
      flex-direction: column;
      gap: 18px;

      &.footer__section-help {
        .footer__logo-social-links {
          display: none;
        }
      }

      .footer__section-title {
        font-size: 14px;
        font-weight: 700;
        line-height: 22px;
      }

      .footer__section-link {
        font-size: 14px;
        line-height: 22px;
        color: #333334;
        text-decoration: none;
        transition: color 0.3s ease;

        &:active,
        &:hover,
        &.active {
          color: #ff5605;
        }
      }
    }

    .footer__section-product {
      max-width: 150px;
    }

    .footer__section-help {
      max-width: 180px;
    }

    .footer__section-documents {
      max-width: max-content;
    }

    .footer__bottom {
      display: flex;
      align-items: center;
      gap: 30px;

      .footer__bottom-copyright {
        font-size: 14px;
        line-height: 22px;
      }

      .footer__bottom-links {
        color: #757981;
        display: flex;
        align-items: center;
        font-size: 14px;
        line-height: 22px;
        gap: 30px;

        a {
          color: #757981;
          text-decoration: none;

          &:hover {
            color: #757981;
          }
        }

        .footer__bottom-link {
          display: flex;
          align-items: center;
          gap: 10px;

          span {
            white-space: nowrap;
          }

          &:first-child {
            svg {
              width: 160px;
              min-width: 160px;
            }
          }

          &:last-child {
            img {
              width: 150px;
              height: 41px;
            }
          }

          svg, img {
            opacity: 0.4;
            transition: opacity .3s ease;
          }

          &:hover {
            svg, img {
              opacity: 1;
            }
          }
        }
      }
    }

    .footer__logo-social-links {
      display: flex;
      align-items: center;
      gap: 14px;

      .footer__logo-social-link {
        position: relative;
        width: 24px;
        height: 24px;

        svg {
          position: absolute;
          left: 0;
          top: 0;
          width: 24px;
          height: 24px;
          min-width: 24px;
          min-height: 24px;
          transition: opacity .3s ease;
        }

        .social-link-image {
          opacity: 0;
        }

        .social-link-image-gray {
          opacity: 1;
        }

        &:hover {
          .social-link-image {
            opacity: 1;
          }

          .social-link-image-gray {
            opacity: 0;
          }
        }
      }
    }
  }
}

@include media-breakpoint-down($size-tablet) {
  footer {
    padding: 0 30px;

    .footer__wrapper {
      .footer__logo {
        max-width: 274px;
      }

      .footer__section-product {
        max-width: 50%;
        flex: 1;
      }

      .footer__section-help {
        max-width: 50%;
        flex: 1;
      }

      .footer__section-documents {
        max-width: 100%;
      }

      .footer__bottom {
        align-items: flex-start;
        justify-content: space-between;

        .footer__bottom-copyright {
          margin-top: 6.5px;
          white-space: nowrap;
        }

        .footer__bottom-links {
          flex-direction: column;
          align-items: flex-end;
          gap: 20px;
          margin-right: 126px;

          .footer__bottom-link {
            white-space: nowrap;

            &:last-child {
              margin-right: 11px;
            }
          }
        }
      }
    }
  }
}

@include media-breakpoint-down($size-mobile) {
  footer {
    padding: 0 20px;

    .footer__wrapper {
      padding: 36px 0 40px;

      .footer__top {
        flex-direction: column;
        gap: 30px;
      }

      .footer__logo {
        display: flex;
        align-items: center;

        .footer__logo-logo-image {
          width: 96px;
          min-width: 96px;
          margin-right: 54px;
        }

        .footer__logo-social-links {
          display: none;
        }
      }

      .footer__content {
        gap: 40px 20px;
      }

      .footer__section {
        &.footer__section-help {
          position: relative;

          .footer__logo-social-links {
            display: flex;
            position: absolute;
            top: -50px;
          }
        }
      }

      .footer__bottom {
        flex-direction: column;

        .footer__bottom-links {
          align-items: flex-start;
          max-width: 400px;
          line-height: 18px;
          margin-right: 0;
          gap: 30px;
          width: 100%;

          .footer__bottom-link {
            white-space: normal;
            justify-content: space-between;
            width: 100%;

            &:first-child {
              svg {
                width: 130.5px;
                min-width: 130.5px;
              }
            }
          }
        }
      }
    }
  }
}

</style>
